import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import commissionsList from "../../../../assets/static_json/commisions.json";
import TransactionStyles from "../../../AgentViews/Transactions/styles";
import Table from "../../../../components/common/Table";
import Modal from "../../../../components/common/Modal";
import {useToasts} from "react-toast-notifications";
import restService from "../../../../services/restService";
import UpdateCommissionConfiguration from "./UpdateCommissionConfiguration";
import Search from "../../../../components/common/Search";
import {Pagination} from "antd";
import PaginationComponent from "../../../../components/common/Pagination";
import SkeletonElement from "../../../../components/Skeletons/SkeletonElement";
import Table2 from "../../../../components/common/Table/Table2";
import Modal2 from "../../../../components/common/Modal/Modal2";
import AddCommissionModal from "./AddCommissionModal";
const renderHeadData = (item, index) => {
  return <th key={index}>{item}</th>;
};

const CommissionConfigurations = () => {
  const {addToast} = useToasts();
  const [commissionToRemove, setCommissionToRemove] = useState(undefined);
  const [commissionToUpdate, setCommissionToUpdate] = useState(undefined);
  const [callback, setCallback] = useState(() => {});
  const [commissions, setCommissions] = useState([]);
  const [pageTo, setPageTo] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [from, setFrom] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showAddCommission, setShowAddCommission] = useState(false);
  const fetchCommissions = (page) => {
    setLoading(true);
    restService.CommissionsConfigApi.getCommissionConfigurations(page)
      .then(({data}) => {
        setCommissions(data?.data?.data);
        setPageTo(data?.data?.to);
        setTotalEntries(data?.data?.total);
        setFrom(data?.data?.from);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCommissions();
  }, []);

  const onCommissionUpdate = () => {
    setCommissionToUpdate(undefined);
    addToast("Successfully Updated Commission", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 5000,
    });
    fetchCommissions();
  };
  const pageChange = (page) => {
    setCurrentPage(page);
    fetchCommissions(page);
  };

  const removeCommission = () => {
    restService.CommissionsConfigApi.removeCommissionConfiguration(
      commissionToRemove.id
    ).then((response) => {
      addToast("Successfully Removed Commission", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setCommissionToRemove(undefined);
      fetchCommissions();
    });
  };
  const renderBodyData = (item, index) => {
    return (
      <tr className="flex flex-col flex-no wrap sm:table-row" key={index}>
        <td className="id"> {item.id}</td>
        <td className="id"> {item.agency?.name}</td>
        <td className="id">
          {" "}
          {item.agent?.firstname} {item.agent?.lastname}
        </td>
        <td className="id"> {item.agency_percentage?.toFixed(2)}</td>
        <td className="id"> {item.agent_percentage?.toFixed(2)}</td>
        <td className="id"> {item.company_percentage?.toFixed(2)}</td>
        <td className="flex">
          <button
            data-tip="Update"
            onClick={() => {
              setCommissionToUpdate(item);
            }}
            className="btn mr-3 border-none outline-none shadow-none focus:outline-none transaction-details"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
              />
            </svg>
          </button>
          <button
            data-tip="Remove"
            onClick={() => {
              setCommissionToRemove(item);
            }}
            className="btn outline-none border-none  shadow-none focus:outline-none transaction-details"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              fill="#d32929"
            >
              <path
                fillRule="evenodd"
                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="content-layout intro-y flex flex-col gap-4 bg-white border rounded-md border-[#ECECEC] pt-5 mt-2">
        <div className="header-layout px-5 flex items-center justify-between sm:flex-row flex-col gap-2">
          <div className="flex md:items-center w-full gap-2 md:flex-row flex-col ">
            <Search
              placeholder={"Search "}
              //   onChange={(e) => searchChargesByInput(e.target.value)}
            />
          </div>

          <div className=" flex flex-col-reverse w-full justify-end sm:flex-row md:items-center">
            <button
              onClick={() => setShowAddCommission(true)}
              className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-700 hover:to-emerald-700 shadow-lg flex items-center gap-2"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M8 12h8" />
                <path d="M12 8v8" />
              </svg>
              <span>Add New Commission</span>
            </button>
          </div>
        </div>

        <TransactionStyles>

          <div className="header-layout gap-2">
            {!loading ? (
              <div className="flex w-full flex-col">
                <Table2
                  // headData={head}
                  tHead={
                    <>
                      <th className="">ID</th>
                      <th className="">Agency</th>
                      <th className="">Agent</th>
                      <th className="">Agency Percentage</th>
                      <th className="">Agent Percentage</th>
                      <th className="">Company Percentage</th>
                      <th className="">Action</th>
                    </>
                  }
                >
                  {commissions.map((item, index) => (
                    <tr key={index} className=" text-[#616161] font-normal">
                      <td>
                        <p className="whitespace-nowrap">{item.id}</p>
                      </td>
                      <td>
                        <p className="whitespace-nowrap">{item.agency?.name}</p>
                      </td>
                      <td>
                        <p className="whitespace-nowrap">
                          {" "}
                          {item.agent?.firstname} {item.agent?.lastname}
                        </p>
                      </td>
                      <td>
                        <p className="">
                          {" "}
                          {item.agency_percentage?.toFixed(2)}
                        </p>
                      </td>
                      <td>
                        <p className=""> {item.agent_percentage?.toFixed(2)}</p>
                      </td>
                      <td>
                        <p className="">
                          {item.company_percentage?.toFixed(2)}
                        </p>
                      </td>
                      <td>
                        <div className="flex items-center gap-3">
                          <button
                            data-tip="Update Commission"
                            onClick={() => {
                              setCommissionToUpdate(item);
                            }}
                            className="p-2 rounded-lg transition-all border-none cursor-pointer shadow-sm hover:shadow-md bg-purple-50 text-purple-600 hover:bg-purple-100"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                              <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                          </button>
                          <button
                            data-tip="Delete Commission"
                            onClick={() => {
                              setCommissionToRemove(item);
                            }}
                            className="p-2 rounded-lg transition-all border-none cursor-pointer shadow-sm hover:shadow-md bg-red-50 text-red-600 hover:bg-red-100"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                              <line x1="10" y1="11" x2="10" y2="17" />
                              <line x1="14" y1="11" x2="14" y2="17" />
                            </svg>
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))}
                </Table2>
              </div>
            ) : (
              <div className="flex w-full flex-col">
                <Table2
                  tHead={
                    <>
                      <th className="">ID</th>
                      <th className="">Agency</th>
                      <th className="">Agent</th>
                      <th className="">Agency Percentage</th>
                      <th className="">Agent Percentage</th>
                      <th className="">Company Percentage</th>
                      <th className="">Action</th>
                    </>
                  }
                    /**
                     * renderHead={(item, index) => renderHeadData(item, index)}
                     */
                >
                  {Array(10)
                    .fill()
                    .map((item, index) => (
                      <tr key={index}>
                        {Array(7)
                          .fill()
                          .map((x, i) => (
                            <td key={i}>
                              <SkeletonElement type={"title"} />
                            </td>
                          ))}
                      </tr>
                    ))}
                </Table2>
              </div>
            )}
          </div>
        </TransactionStyles>
      </div>

      <div className="flex flex-col mb-[10vh] px-5 gap-4 justify-between md:items-center md:flex-row mt-8">
        <div className="page text-[#999999] text-xs">
          {loading
            ? ""
            : commissions && commissions.length <= 0
            ? "No Transactions Found"
            : `Showing  ${pageTo} out of ${totalEntries} results`}
        </div>

        <div className="mt-3  flex justify-end float-right">
          <PaginationComponent
            current={currentPage}
            defaultCurrent={currentPage}
            showSizeChanger={false}
            onChange={pageChange}
            total={totalEntries}
          />
        </div>
      </div>

      {commissionToRemove && (
        <Modal2
          size="medium"
          onHide={() => {
            setCommissionToRemove(undefined);
          }}
        >
          <div className="flex flex-col items-center gap-6 justify-center py-8 px-8">
            {/* Modern Warning Icon */}
            <div className="p-4 bg-red-100 rounded-full">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-red-600">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <path d="M12 17h.01" />
              </svg>
            </div>

            <div className="flex items-center flex-col gap-3 justify-center w-full text-center">
              <h1 className="text-2xl font-bold text-gray-900">
                Delete Commission Configuration?
              </h1>

              <p className="text-sm text-gray-600 max-w-md">
                Are you sure you want to delete this commission configuration? This action cannot be undone and will permanently remove all associated data.
              </p>
            </div>

            <div className="flex items-center gap-4 mt-4">
              <button
                onClick={() => setCommissionToRemove(undefined)}
                className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-md"
              >
                Cancel
              </button>
              <button
                onClick={() => removeCommission()}
                className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-red-600 to-red-700 text-white hover:from-red-700 hover:to-red-800 shadow-lg flex items-center gap-2"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
                Delete Commission
              </button>
            </div>
          </div>
        </Modal2>
      )}

      {commissionToUpdate && (
        <Modal2
          size={"lg"}
          //   onClick={callback}
          //   modalTitle="Update Commission"
          //   buttonTitle="Update Charge"
          //   buttonColor="bg-blue-600"

          onHide={() => {
            setCommissionToUpdate(undefined);
          }}
        >
          <UpdateCommissionConfiguration
            commission={commissionToUpdate}
            initCallback={(callbackFunc) => setCallback(() => callbackFunc)}
            onSubmit={onCommissionUpdate}
            setCommissionToUpdate={setCommissionToUpdate}
          />
        </Modal2>
      )}

      {showAddCommission && (
        <AddCommissionModal setShow={setShowAddCommission} />
      )}
    </>
  );
};
export default CommissionConfigurations;
